export default function($) {
  let mobileSwiper = document.querySelector('.js-mobile-slider');
  let initMobileSwiper = false;

  const mobileSwiperParams = {
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".mobile-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 1.3,
        spaceBetween: 32,
      },
    },
  };

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  const homeSwiper = new Swiper('.js-home-slider', {
    loop: true,
    slidesPerView: 1,
    speed: 750,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      enabled: true,
    },
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        pagination: {
          enabled: true,
        },
        navigation: {
          enabled: true,
        }
      },
      768: {
        pagination: {
          enabled: false,
        },
        navigation: {
          enabled: true,
        }
      }
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
        $('.swiper-button').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
        $('.swiper-button').show();
      },
    }
  });

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( !initMobileSwiper ) {
        initMobileSwiper = true;

        $('.js-mobile-slider').each(function(index) {
          let sliderDiv = $(this)[0]
          mobileSwiper = new Swiper(sliderDiv, mobileSwiperParams);
        })
      }
    }
    else {
      if( $('.js-mobile-slider').length) {
        $('.js-mobile-slider').each( function() {
          let sliderDiv = $(this)[0]
          if (sliderDiv.swiper) {
            sliderDiv.swiper.destroy(false,true)
          }
        })

        initMobileSwiper = false
      }

    }
  }
}
